import debounce from 'lodash.debounce';
import { store } from 'store/store';
import { mediaDevicesChangeStarted } from 'features/user-media/actions';
import { logger } from 'utils/logger';
import { addDeviceChangeListener, removeDeviceChangeListener } from 'features/user-media/utils';

export class DeviceChangeMonitorClass {
  private listener: ReturnType<typeof debounce> | null = null;

  private isActive = false;

  start = () => {
    if (this.isActive) {
      return;
    }

    this.listener = debounce(() => {
      store.dispatch(mediaDevicesChangeStarted());
    }, 300);

    addDeviceChangeListener(this.listener);
    this.isActive = true;

    logger
      .remote({ system: true, capture: 'media-devices' })
      .info('[DeviceChangeMonitor] Started monitoring device changes in room');
  };

  stop = () => {
    if (!this.isActive || !this.listener) {
      return;
    }

    removeDeviceChangeListener(this.listener);
    this.listener.cancel();
    this.listener = null;
    this.isActive = false;

    logger
      .remote({ system: true, capture: 'media-devices' })
      .info('[DeviceChangeMonitor] Stopped monitoring device changes in room');
  };

  isMonitoring = () => this.isActive;
}

export const DeviceChangeMonitor = new DeviceChangeMonitorClass();
